import { NodeProps } from "@xyflow/react";
import { FormValues } from "features/entities/EntityCreatePage/EntityCreatePage";
import { getNodeFromType } from "features/entities/EntityCreatePage/EntityGraph/nodes/nodeUtils";
import { type DraftNode as NodeType } from "features/entities/EntityCreatePage/EntityGraph/nodes/types";
import startCase from "lodash-es/startCase";
import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

// eslint-disable-next-line unused-imports/no-unused-vars
export const DraftNode = ({ data: _data, ...other }: NodeProps<NodeType>) => {
  const methods = useFormContext<FormValues>();
  const values = methods.watch();

  const { type: Node, backgroundColor } = getNodeFromType(
    values.entity_data.functional_type,
  );
  const { t } = useTranslation(["common", "entity"]);
  return (
    <Node
      {...other}
      data={{
        backgroundColor,
        label:
          values.entity_data.legal_name ||
          startCase(values.entity_data.functional_type) ||
          t("entity:create.draft"),
      }}
    />
  );
};
